import {useQuery} from "@tanstack/react-query";
import {IHeader} from "../declarations";
import {createApiClient} from "../utilities/apiClient";

const getSailInfoHeader=async (guid: string): Promise<IHeader> => {
    const axiosSailTag=createApiClient();
    const response=await axiosSailTag.get<IHeader>(`/api/SailInfo/GetSailInfoHeader/${encodeURIComponent(guid)}`);
    return response.data;
};

export const useGetSailInfoHeader=(guid: string) =>
    useQuery<IHeader>({
        queryKey: [
            "GetSailInfoHeader",
            {
                guid: guid??null
            }
        ],
        queryFn: () => {
            if(!guid?.trim()) {
                throw new Error("Invalid params for GetSailInfoHeader");
            }
            return getSailInfoHeader(guid);
        },
        enabled: Boolean(guid?.trim()),
        refetchOnWindowFocus: true,
        retry: false
    });